import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

function MedicalRecordForm() {
  const { handleAPICall } = useAuth();
  const [formData, setFormData] = useState({
    patientId: '',
    recordType: '',
    visitDate: '',
    weight: '',
    bloodPressure: '',
    temperature: '',
    notes: '',
    apiType: 'medicalRecords'
  });

  const [errors, setErrors] = useState({
    patientId: false,
    recordType: false,
    visitDate: false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {
      patientId: !formData.patientId,
      recordType: !formData.recordType,
      visitDate: !formData.visitDate
    };
    
    setErrors(newErrors);
    if (Object.values(newErrors).some(error => error)) return;

    try {
      await handleAPICall(formData);
      // Reset form after submission
      setFormData({
        patientId: '',
        recordType: '',
        visitDate: '',
        weight: '',
        bloodPressure: '',
        temperature: '',
        notes: '',
        apiType: 'medicalRecords'
      });
    } catch (error) {
      console.error('Medical record submission failed:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: false }));
  };

  return (
    <form 
      onSubmit={handleSubmit}
      className="p-5 bg-white rounded-4 shadow-lg mt-5"
      style={{ maxWidth: '', margin: '0 auto' }}
    >
      <h2 className="mb-2 text-primary text-center fw-bold">Medical Record Entry</h2>

      <div className="row g-4 mb-2">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Patient *</label>
            <select
              name="patientId"
              value={formData.patientId}
              onChange={handleChange}
              className={`form-select border-bottom border-light py-2 w-100 ${errors.patientId ? 'is-invalid' : ''}`}
            >
              <option value="">Select Patient</option>
              <option value="1">Patient 1</option>
              <option value="2">Patient 2</option>
            </select>
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Record Type *</label>
            <select
              name="recordType"
              value={formData.recordType}
              onChange={handleChange}
              className={`form-select border-bottom border-light py-2 w-100 ${errors.recordType ? 'is-invalid' : ''}`}
            >
              <option value="">Select Type</option>
              <option value="antenatal">Antenatal</option>
              <option value="postnatal">Postnatal</option>
              <option value="child">Child</option>
              <option value="general">General</option>
            </select>
          </div>
        </div>
      </div>

      <div className="row g-4 mb-2">
        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Visit Date *</label>
            <input
              type="date"
              name="visitDate"
              value={formData.visitDate}
              onChange={handleChange}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.visitDate ? 'is-invalid' : ''}`}
            />
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Weight (kg)</label>
            <input
              type="number"
              name="weight"
              step="0.1"
              value={formData.weight}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2 px-0"
              placeholder="Enter weight"
            />
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Blood Pressure</label>
            <input
              type="text"
              name="bloodPressure"
              value={formData.bloodPressure}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2 px-0"
              placeholder="120/80"
            />
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Temperature (°C)</label>
            <input
              type="number"
              name="temperature"
              step="0.1"
              value={formData.temperature}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2 px-0"
              placeholder="37.0"
            />
          </div>
        </div>

      </div>

      <div className="row g-4 mb-4">
        <div className="col-md-12">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Notes</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              className="form-control bg-light border-0 rounded-3 p-3"
              rows="3"
              placeholder="Additional notes..."
            ></textarea>
          </div>
        </div>
      </div>

      <div className="d-grid mt-5">
        <button 
          type="submit"
          className="btn btn-primary btn-lg py-3 fw-bold hover-effect w-100"
          disabled={!formData.patientId || !formData.recordType || !formData.visitDate}
        >
          Save Medical Record
        </button>
      </div>
    </form>
  );
}

export default MedicalRecordForm;